<template>
    <b-table-lite :items="items" :fields="fields" />
</template>
<script>
    export default {
        name: 'ProjectDroppedServicesTable',
        props: {
            items: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                fields: [
                    {
                        key: 'name',
                        label: this.$t('Disability'),
                    },
                    {
                        key: 'type',
                        label: this.$t('Type'),
                        formatter: 'typeFormatter'
                    },
                    {
                        key: 'drop_notice',
                        label: this.$t('Notice')
                    }
                ]
            }
        },

        methods: {
            typeFormatter(type) {
                return this.$t(type)
            }
        }
    }
</script>
